import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import axios from "axios";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { Button, Grid } from "@material-ui/core";
import {
  FormControl,
  Select,
  OutlinedInput,
  MenuItem,
  InputLabel,
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import config from "../../config";
import ReactDOM from "react-dom";

const BACKEND_URL = config.backend.host;

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing(),
    minWidth: 120,
  },
  textField: {
    marginLeft: 10,
    marginRight: 10,
    width: "250px",
  },
  dense: {
    marginTop: 16,
  },
  menu: {
    width: 200,
  },
  button: {
    margin: theme.spacing(),
  },
  leftIcon: {
    marginRight: theme.spacing(),
    fontSize: 20,
  },
});

class LocationAdd extends Component {
  state = {
    name: "",
    phone_number: "",
    address: "",
    city: "",
    province: "",
    country: "",
    zip_code: "",
    latitude: "",
    longitude: "",
    title: "Add",
    isEdit: false,
    labelWidth: 0,
    typeList: ["Retail", "Clinic"],
  };
  constructor(props) {
    super(props);
    this.btnSaveOnClick = this.btnSaveOnClick.bind(this);
    this.btnCancelOnClick = this.btnCancelOnClick.bind(this);
    //TODO: use the json from the previously call, if possible
    if (props.match.params.id) {
      //TODO: remove magic string
      axios
        .get(BACKEND_URL + "/location/" + props.match.params.id)
        .then((response) => this.loadData(response.data))
        .catch((err) => {
          // console.log(err)
        });
    }
  }

  componentDidMount() {
    this.setState({
      labelWidth: ReactDOM.findDOMNode(this.InputLabelRef).offsetWidth, //used to fix select's border
    });
  }

  loadData(location) {
    this.setState({
      _id: location._id,
      name: location.name,
      type: location.type,
      phone_number: location.phone_number,
      address: location.address,
      city: location.city,
      province: location.province,
      country: location.country,
      zip_code: location.zip_code,
      latitude: location.latitude,
      longitude: location.longitude,
      title: "Edit",
      isEdit: true,
    });
  }

  btnCancelOnClick(e) {
    e.preventDefault();
    this.props.history.goBack();
  }

  btnSaveOnClick(e) {
    e.preventDefault();
    const obj = {
      name: this.state.name,
      type: this.state.type,
      phone_number: this.state.phone_number,
      address: this.state.address,
      city: this.state.city,
      province: this.state.province,
      country: this.state.country,
      zip_code: this.state.zip_code,
      latitude: this.state.latitude,
      longitude: this.state.longitude,
    };
    // console.log("Data sending", obj);
    //TODO: show message DONE with snackbar
    if (this.state.isEdit) {
      axios({
        method: "put",
        url: `${BACKEND_URL + `/location/${this.state._id}`}`,
        data: { obj },
      })
        .then((res) => {
          // console.log(res);
          if (res.data && res.data.status === "REQUEST_DENIED") {
            alert("Error: " + res.data.message);
          } else {
            this.saveSuccess(res);
          }
        })
        .catch(
          (e) => {
            // console.log(e);
            // console.log(e.response);
          }
          // alert(`Error: ${e} | Response: ${e.response.data.message}`)
        );
    } else {
      axios
        .post(BACKEND_URL + "/location", obj)
        .then((res) => {
          // console.log(res);
          if (res.data && res.data.status === "REQUEST_DENIED") {
            alert("Error: " + res.data.message);
          } else {
            this.saveSuccess(res);
          }
        })
        .catch(
          (e) => {
            // console.log(e);
            // console.log(e.response);
          }
          // alert(`Error: ${e} | Response: ${e.response.data.message}`)
        );
    }
  }
  saveSuccess(response) {
    //TODO: Set a snack bar with Redux to show messages after saving
    alert("Saved");
    this.props.history.goBack();
  }

  handleChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Typography variant="h4" gutterBottom>
          {this.state.title} Location
        </Typography>
        <Grid container>
          <form
            className={classes.container}
            autoComplete="off"
            onSubmit={this.btnSaveOnClick}
          >
            <Grid item xs={9}>
              <TextField
                id="tfName"
                label="Name"
                margin="normal"
                variant="outlined"
                required
                style={{ width: "98%", marginLeft: 10 }}
                value={this.state.name}
                onChange={this.handleChange("name")}
              />
            </Grid>
            <Grid item xs={3}>
              {/* <TextField id="tfType" label="Type" 
                margin="normal" variant="outlined" 
                required
                style={{marginLeft:10}}
                value={this.state.type}
                onChange={this.handleChange('type')}
              /> */}
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel
                  ref={(ref) => {
                    this.InputLabelRef = ref;
                  }}
                  htmlFor="outlined-type"
                >
                  Type
                </InputLabel>
                <Select
                  value={this.state.type}
                  onChange={this.handleChange("type")}
                  input={
                    <OutlinedInput
                      labelWidth={this.state.labelWidth}
                      name="type"
                      id="outlined-type"
                    />
                  }
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {this.state.typeList.map((t) => (
                    <MenuItem value={t}>{t}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="tfNumber"
                label="Phone Number"
                className={classes.textField}
                margin="normal"
                variant="outlined"
                required
                value={this.state.phone_number}
                onChange={this.handleChange("phone_number")}
              />
            </Grid>
            <Grid item xs={8}>
              <TextField
                id="tfStreetAddress"
                label="Address"
                className={classes.textField}
                margin="normal"
                variant="outlined"
                style={{ width: "97%", marginLeft: 10 }}
                value={this.state.address}
                required
                onChange={this.handleChange("address")}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="tfZipCode"
                label="Zip Code"
                className={classes.textField}
                margin="normal"
                variant="outlined"
                value={this.state.zip_code}
                onChange={this.handleChange("zip_code")}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="tfCity"
                label="City"
                className={classes.textField}
                margin="normal"
                variant="outlined"
                required
                value={this.state.city}
                onChange={this.handleChange("city")}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="tfProvince"
                label="Province"
                className={classes.textField}
                margin="normal"
                variant="outlined"
                value={this.state.province}
                onChange={this.handleChange("province")}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="tfCountry"
                label="Country"
                className={classes.textField}
                margin="normal"
                variant="outlined"
                value={this.state.country}
                onChange={this.handleChange("country")}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="tfLatitude"
                disabled
                label="Latitude"
                className={classes.textField}
                margin="normal"
                variant="outlined"
                value={this.state.latitude}
                onChange={this.handleChange("latitude")}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="tfLongitude"
                disabled
                label="Longitude"
                className={classes.textField}
                margin="normal"
                variant="outlined"
                value={this.state.longitude}
                onChange={this.handleChange("longitude")}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                size="medium"
                className={classes.button}
                name="btnSave"
                type="submit"
                onClick={this.btnSaveOnClick}
              >
                <SaveIcon className={classes.leftIcon} />
                Save
              </Button>
              <Button
                variant="contained"
                size="medium"
                className={classes.button}
                onClick={this.btnCancelOnClick}
              >
                <CancelIcon className={classes.leftIcon} />
                Cancel
              </Button>
            </Grid>
          </form>
        </Grid>
      </div>
    );
  }
}

LocationAdd.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LocationAdd);
